'use client';
import styled from 'styled-components';
import { fromMd, untilMd } from '../../constants';
export const Container = styled.div `
  display: inline-block;
  position: relative;

  ${fromMd} {
    font-size: ${o => (typeof o.$starSize === 'string' ? o.$starSize : o.$starSize.md)};
  }

  ${untilMd} {
    font-size: ${o => (typeof o.$starSize === 'string' ? o.$starSize : o.$starSize.sm)};
  }
`;
export const StarOutlines = styled.span `
  &::after {
    display: inline-block;
    letter-spacing: 0.5em;
    content: '☆☆☆☆☆';
  }

  @-moz-document url-prefix() {
    &::after {
      content: '★★★★★';
      opacity: 0.2;
      font-size: 1.75em;
      letter-spacing: 0.2em;
      top: -0.1em;
      position: relative;
    }
  }
`;
const STAR_WIDTH_WITH_PADDING = 1.5;
export const FilledStars = styled.span `
  inset-inline-start: 0;
  top: 0;
  overflow: hidden;
  position: absolute;

  width: ${o => STAR_WIDTH_WITH_PADDING * Math.min(5, Math.max(0, o.rating))}em;

  &::after {
    display: inline-block;
    letter-spacing: 0.5em;
    content: '★★★★★';
  }

  @-moz-document url-prefix() {
    font-size: 1.75em;

    &::after {
      letter-spacing: 0.2em;
      top: -0.1em;
      position: relative;
    }
  }
`;
//# sourceMappingURL=styles.js.map